export const CONTACT_EMAIL = "raymond@clarke-process-automation.com";
